// components/About.js - UPDATED WITH YOUR IMAGE
import React from 'react';
import { FaBullseye, FaEye, FaStar } from 'react-icons/fa';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-title">
          <h2>MISSION, VISION & VALUES</h2>
          <p>Our guiding principles that drive our commitment to solar energy solutions.</p>
        </div>
        
        <div className="about-content">
          <div className="mv-content">
            <div className="mv-grid">
              <div className="mv-item">
                <div className="mv-icon">
                  <FaBullseye />
                </div>
                <h3>MISSION</h3>
                <h4>Our Mission</h4>
                <p>To provide solar powered systems with professionalism, integrity, and excellence. We are committed to delivering reliable, high-quality solar solutions that meet our clients' energy needs while promoting sustainable development in Malawi and beyond.</p>
              </div>
              
              <div className="mv-item">
                <div className="mv-icon">
                  <FaEye />
                </div>
                <h3>VISION</h3>
                <h4>Our Vision</h4>
                <p>To be the leading and most trusted provider of solar energy solutions in Malawi and the surrounding region. We aim to transform energy accessibility through innovative solar technologies and contribute to a sustainable, energy-independent future for all.</p>
              </div>
              
              <div className="mv-item">
                <div className="mv-icon">
                  <FaStar />
                </div>
                <h3>VALUES</h3>
                <h4>Our Core Values</h4>
                <div className="values-list">
                  <div className="value-item">
                    <span className="value-badge">Integrity</span>
                    <p>We conduct our business with honesty, transparency, and ethical practices.</p>
                  </div>
                  <div className="value-item">
                    <span className="value-badge">Professionalism</span>
                    <p>We maintain the highest standards in our work, from design to installation.</p>
                  </div>
                  <div className="value-item">
                    <span className="value-badge">Punctuality</span>
                    <p>We respect our clients' time and deliver services as promised.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="about-image">
            <div className="image-frame">
              {/* Use your image from public/images folder */}
              <div className="real-image-container">
                <img 
                  src="/images/6.jpg"  
                  alt="Sunsight Energy - Professional Solar Solutions in Malawi"
                  className="real-about-image"
                  onError={(e) => {
                    // Fallback if image doesn't exist
                    console.error('Image failed to load:', e.target.src);
                    e.target.onerror = null;
                    e.target.src = "/images/1.jpg"; // Fallback to another of your images
                  }}
                />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <span className="image-text">Sunsight Energy Ltd</span>
                    <span className="image-subtext">Professional Solar Solutions Since 2018</span>
                  </div>
                </div>
              </div>
              <div className="image-badge">
                <span>Since 2018</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="company-background">
          <h3>Company Background</h3>
          <div className="background-grid">
            <div className="bg-item">
              <span className="bg-number">2018</span>
              <p>Year Established</p>
            </div>
            <div className="bg-item">
              <span className="bg-icon">🏢</span>
              <p>Registered in Malawi</p>
            </div>
            <div className="bg-item">
              <span className="bg-icon">⚡</span>
              <p>MERA Class E Certified</p>
            </div>
            <div className="bg-item">
              <span className="bg-icon">📋</span>
              <p>PPDA Registered</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;